import { useNavigate } from '@/hooks/useNavigate.ts';
import { useQuestionsAnswers } from '@/hooks/useQuestionsAnswers';
import LayoutContainer, { LayoutContainerProps } from '@/components/LayoutPageMobile/LayoutContainer.tsx';

export default function LayoutPageMobile(props: Omit<LayoutContainerProps, 'onBackToStartClick'>) {
  const { setCurrentQuestionNumber } = useQuestionsAnswers();
  const navigate = useNavigate();
  return (
    <LayoutContainer
      {...props}
      onBackToStartClick={() => {
        setCurrentQuestionNumber(0);
        sessionStorage.clear();
        navigate('/');
      }}
    />
  );
}
